const teal = {
  teal1: "hsl(168, 48.0%, 6.5%)",
  teal2: "hsl(169, 77.8%, 7.1%)",
  teal3: "hsl(170, 76.1%, 9.2%)",
  teal4: "hsl(171, 75.8%, 11.0%)",
  teal5: "hsl(171, 75.7%, 12.8%)",
  teal6: "hsl(172, 75.8%, 15.1%)",
  teal7: "hsl(172, 76.7%, 18.6%)",
  teal8: "hsl(173, 80.2%, 23.7%)",
  teal9: "hsl(173, 80.0%, 36.0%)",
  teal10: "hsl(174, 83.9%, 38.2%)",
  teal11: "hsl(174, 90.0%, 40.7%)",
  teal12: "hsl(166, 73.0%, 93.1%)"
};
export { teal };
//# sourceMappingURL=teal.mjs.map
